import { render, staticRenderFns } from "./crossfilter-page.vue?vue&type=template&id=30fc08ec&"
import script from "./crossfilter-page.vue?vue&type=script&lang=js&"
export * from "./crossfilter-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports